/* Keep Shrine's drawer ARIA state aligned after its delayed close animation. */
(function () {
  if (window.__scHeaderA11yInstalled) return;
  window.__scHeaderA11yInstalled = true;

  var desktopQuery = window.matchMedia('(min-width: 990px)');

  function syncDrawer(details) {
    var summary = details.querySelector(':scope > summary');
    if (!summary) return;

    summary.setAttribute('aria-expanded', String(details.open));
    if (details.open) return;

    details.classList.remove('menu-opening');
    var header = details.closest('.section-header');
    if (header) header.classList.remove('menu-open');
  }

  function install() {
    document.querySelectorAll('header-drawer > details').forEach(function (details) {
      if (details.dataset.scA11ySync === 'true') return;
      details.dataset.scA11ySync = 'true';
      var closeButton = details.querySelector('.menu-drawer__close-menu-btn');
      if (closeButton && !closeButton.getAttribute('aria-label')) {
        closeButton.setAttribute('aria-label', 'Close menu');
      }
      details.addEventListener('toggle', function () {
        syncDrawer(details);
      });
      syncDrawer(details);
    });

    document.querySelectorAll('.section-header .header__inline-menu header-menu > details').forEach(function (details) {
      if (details.dataset.scDesktopHover === 'true') return;
      details.dataset.scDesktopHover = 'true';

      var summary = details.querySelector(':scope > summary');
      var closeTimer;

      function openMenu() {
        if (!desktopQuery.matches) return;
        window.clearTimeout(closeTimer);
        details.open = true;
        if (summary) summary.setAttribute('aria-expanded', 'true');
      }

      function closeMenu() {
        if (!desktopQuery.matches) return;
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(function () {
          if (details.matches(':hover') || details.contains(document.activeElement)) return;
          details.open = false;
          if (summary) summary.setAttribute('aria-expanded', 'false');
        }, 120);
      }

      details.addEventListener('mouseenter', openMenu);
      details.addEventListener('mouseleave', closeMenu);
      details.addEventListener('focusin', openMenu);
      details.addEventListener('focusout', closeMenu);
    });
  }

  install();
  document.addEventListener('shopify:section:load', install);
  desktopQuery.addEventListener('change', function (event) {
    if (event.matches) return;
    document.querySelectorAll('.section-header .header__inline-menu header-menu > details[open]').forEach(function (details) {
      details.open = false;
      var summary = details.querySelector(':scope > summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    });
  });
})();
